<template>
	<n-config-provider :theme-overrides="themeOverrides">
		<section class="desktop-layout">
			<PcHeader v-if="showNav" />
			<ClientOnly>
				<PcLogin
					v-if="showLogin"
					:key="loginPresetVersion"
					v-model="showLogin"
					:backUrl="backUrl"
					:presetData="loginPresetData"
					:trigger-source="loginTriggerSource"
				/>
				<PcEmailOfficail v-if="showEmailOfficail" v-model="showEmailOfficail" />
				<AppDownloadModal v-if="shouldMountSupportWidgets && !isInAppEnv" />
				<KeFu v-if="shouldMountSupportWidgets && !isInAppEnv" />
				<FloatSidebar v-if="shouldMountSupportWidgets && showFloatSidebar" />
			</ClientOnly>
			<main role="main">
				<slot />
			</main>
			<PcFooter v-if="showFooter" :isLogin="isLoggedIn" :lang="pcFooterLang" />
		</section>
	</n-config-provider>
</template>

<script setup>
import { computed, defineAsyncComponent } from "vue";
import PcHeader from "~/components/pc/header/pc-header.vue";
import PcFooter from "~/components/footer/pc-footer.vue";
import { useSiteShell } from "~/composables/useSiteShell";
import { stripLocalePrefix } from "~/utils/i18n-locale-routes";

const PcLogin = defineAsyncComponent(() => import("~/components/pc/login/pc-login.vue"));
const KeFu = defineAsyncComponent(() => import("~/components/kefu/index.vue"));
const FloatSidebar = defineAsyncComponent(() => import("~/components/pc/float-sidebar/index.vue"));
const PcEmailOfficail = defineAsyncComponent(
	() => import("~/components/pc/email-officail/pc-email-officail.vue")
);
const AppDownloadModal = defineAsyncComponent(
	() => import("~/components/pc/app-download-modal/index.vue")
);

const {
	pcFooterLang,
	showNav,
	showFooter,
	isInAppEnv,
	shouldMountSupportWidgets,
	showLogin,
	isLoggedIn,
	loginPresetData,
	loginPresetVersion,
	loginTriggerSource,
	showEmailOfficail,
	backUrl,
	themeOverrides,
} = useSiteShell();

const route = useRoute();

/** 与 PC 主导航四项一致：首页 / 媒体广场 / 服务机构 / 关于我们 */
const isMainNavRoute = path => {
	if (path === "/") return true;
	if (path === "/seer/square" || path.startsWith("/seer/square/")) return true;
	if (path === "/seer/service-institution" || path.startsWith("/seer/service-institution/")) {
		return true;
	}
	if (path === "/seer/aboutus" || path.startsWith("/seer/aboutus/")) return true;
	return false;
};

const showFloatSidebar = computed(() => isMainNavRoute(stripLocalePrefix(route.path || "")));
</script>
